import { Stage } from '@oneaudi/avp-hck-dga-customerui-commons';

const extractedStageFrom = (hostname: string): Stage => {
  const matchedGroups = hostname.match(/cupra.([a-z]+).dga.avp.tech/);
  if (matchedGroups !== null) {
    const stage = matchedGroups[1].toLowerCase();
    switch (stage) {
      case 'dev':
        console.info(`Initializing DGA on Stage: ${[Stage.DEV]}`);
        return Stage.DEV;
      case 'test':
        console.info(`Initializing DGA on Stage: ${[Stage.TEST]}`);
        return Stage.TEST;
    }
  }

  console.warn(`Unable to extract stage from ${hostname}. Falling back to DEV stage.`);
  return Stage.DEV;
};

export const fromDerivedStage: (hostname: string) => Stage = (hostname: string) => {
  if (!hostname) {
    console.info(`Initializing DGA on Stage: ${[Stage.DEV]}`);
    return Stage.DEV;
  }

  if (hostname === 'cupra.dga.avp.tech') {
    console.info(`Initializing DGA on Stage: ${[Stage.PROD]}`);
    return Stage.PROD;
  }

  if (hostname === 'localhost') {
    console.info(`Initializing DGA on Stage: ${[Stage.DEV]}`);
    return Stage.DEV;
  }
  return extractedStageFrom(hostname);
};

export const getStage = (): Stage => {
  return fromDerivedStage(new URL(window.location.href).hostname);
};
